enum zIndexes {
  low = 1,
  medium = 100,
  high = 1000,
  overHigh = 1001,
}

export default zIndexes;
